export const deleteCookie = () => {
  document.cookie = `accessToken =; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  document.cookie = `idToken =; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  document.cookie = `refreshToken =; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
